<script lang="ts" setup>
import { ref, watch } from 'vue'

const props = defineProps<{
  modelValue?: string
  error?: string
  label: string
  name: string
  id: string
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', value: string): void
}>()

const model = ref(props.modelValue || '')

watch(
  () => props.modelValue,
  (value) => {
    if (model.value && value !== model.value) {
      model.value = value || ''
    }
  },
)

watch(model, (value) => {
  emit('update:modelValue', value)
})
</script>

<template>
  <textarea
    :id="props.id"
    v-model="model"
    :aria-invalid="!!error"
    :aria-describedby="error ? 'subscribe-email-error' : undefined"
    :name="name"
    :placeholder="label"
    class="card min-h-[120px] w-full pl-[56px] pr-[16px] pt-[8px] text-gray-700"
  />
</template>
